import React from 'react'
import PropTypes from 'prop-types'
import 'flag-icon-css/css/flag-icon.min.css'

import './Flag.css'


export default function Flag ({ country, size, onClick }) {
  return (
    <i className={`flag-icon flag-icon-${country} flag-icon-${size}`} onClick={e => onClick && onClick(e, country)} />
  )
}

Flag.propTypes = {
  /** 具体国家 */
  country: PropTypes.string,
  /** 国旗尺寸 */
  size: PropTypes.oneOf(['small', 'normal', 'large']),
  /** 国旗点击事件 */
	onClick: PropTypes.func
}

Flag.defaultProps ={
  country: 'cn',
  size: 'normal'
}


// WEBPACK FOOTER //
// ./src/components/Flag/Flag.jsx